import React from "react";
import CardClasses from "./Cards.module.css";
import Icon1 from "Assets/About/principle_1.png";
import Icon2 from "Assets/About/principle_2.png";
import Icon3 from "Assets/About/principle_3.png";

const Card = [
    {
        icon: Icon1,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We bring order to chaos",
    },
    {
        icon: Icon2,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We do it right the first time",
    },
    {
        icon: Icon3,
        Content:
            "At Executive Tax and Accounting Services. there are no excuses. If you need a service provided, we will find a way to complete. it, Our paperwork is accurate and always up to date.",
        heading: "You need it? We provide it",
    },
];

function Cards() {
    return (
        <div className={CardClasses["Container"]}>
            <h3>Our Principles</h3>
            <p>
                We guide our clients through a full range of tax planning and
                preparation decisions with strategies that minimize your tax
                liabilities
            </p>
            <div className={CardClasses["Cards-wrapper"]}>
                {Card.map((item) => (
                    <div className={CardClasses["card"]}>
                        {/* <div className={CardClasses["icon-wrapper"]}>
                    </div> */}
                        <img src={item.icon} />
                        <h3>{item.heading}</h3>
                        <p>{item?.Content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Cards;
